import Lenis from '@studio-freight/lenis'
import timeSong from 'url:./songs/time.mp3'
import fadingSong from 'url:./songs/fading-from-your-mind.mp3'
import fracturedSong from 'url:./songs/fractured-within.mp3'
import leftSong from 'url:./songs/left-behind.mp3'
import youdnsSong from 'url:./songs/you-did-not-stay.mp3'

const lenis = new Lenis()

// Video/Audio Mapping
const songMap = {
    'time': timeSong,
    'fading-from-your-mind': fadingSong,
    'fractured-within': fracturedSong,
    'left-behind': leftSong,
    'you-did-not-stay': youdnsSong
};

function raf(time) {
  lenis.raf(time)
  requestAnimationFrame(raf)
}

requestAnimationFrame(raf)

console.log("Mithras site loaded with smooth scroll.");

// Audio Player Logic
// Audio Player Logic
document.addEventListener('DOMContentLoaded', () => {
    // 1. Setup Audio & Web Audio API
    const audio = new Audio();
    // Allow cross-origin for audio analysis if needed (though files are local/bundled)
    audio.crossOrigin = "anonymous";
    
    let audioContext;
    let analyser;
    let source;
    
    const songList = document.getElementById('song-list');
    const playIcons = document.querySelectorAll('.play-icon');
    const progressBar = document.getElementById('progress');
    const progressContainer = document.getElementById('progress-container');
    const currentTimeEl = document.getElementById('current-time');
    const durationEl = document.getElementById('duration');
    
    // Waveform Canvas Setup
    const canvas = document.getElementById('waveform-canvas');
    let canvasCtx;
    if (canvas) {
        canvasCtx = canvas.getContext('2d');
    }
    let animationId;

    let currentTrackIndex = -1;
    let isPlaying = false;

    // Initialize Audio Context on first interaction
    function initAudioContext() {
        if (!audioContext) {
            audioContext = new (window.AudioContext || window.webkitAudioContext)();
            analyser = audioContext.createAnalyser();
            analyser.fftSize = 2048; // Increased from 256 for more condensed/detailed wave
            
            source = audioContext.createMediaElementSource(audio);
            source.connect(analyser);
            analyser.connect(audioContext.destination);
        }
        if (audioContext.state === 'suspended') {
            audioContext.resume();
        }
    }

    // Draw Waveform Loop
    function drawWaveform() {
        if (!isPlaying || !analyser || !canvasCtx) return;

        animationId = requestAnimationFrame(drawWaveform);

        const bufferLength = analyser.frequencyBinCount;
        const dataArray = new Uint8Array(bufferLength);
        
        analyser.getByteTimeDomainData(dataArray);

        // Clear canvas
        canvasCtx.fillStyle = window.getComputedStyle(document.documentElement).getPropertyValue('--bg-color') || '#ffffff';
        canvasCtx.fillRect(0, 0, canvas.width, canvas.height);

        canvasCtx.lineWidth = 3; // Bolder line
        // "Offset black" - using a dark grey/charcoal
        canvasCtx.strokeStyle = '#333333'; 
        canvasCtx.beginPath();

        const sliceWidth = canvas.width * 1.0 / bufferLength;
        let x = 0;

        for (let i = 0; i < bufferLength; i++) {
            const v = dataArray[i] / 128.0; // Normalize to [0, 2]
            const y = v * canvas.height / 2; // Scale to canvas height

            if (i === 0) {
                canvasCtx.moveTo(x, y);
            } else {
                canvasCtx.lineTo(x, y);
            }

            x += sliceWidth;
        }

        canvasCtx.lineTo(canvas.width, canvas.height / 2);
        canvasCtx.stroke();
    }

    // Draw Flat Line (Resume initial state)
    function drawFlatLine() {
        if (animationId) cancelAnimationFrame(animationId);
        
        if (!canvasCtx) return;

        canvasCtx.fillStyle = window.getComputedStyle(document.documentElement).getPropertyValue('--bg-color') || '#ffffff';
        canvasCtx.fillRect(0, 0, canvas.width, canvas.height);

        canvasCtx.lineWidth = 3; // Keep bold width
        canvasCtx.strokeStyle = '#333333';
        canvasCtx.beginPath();
        canvasCtx.moveTo(0, canvas.height / 2);
        canvasCtx.lineTo(canvas.width, canvas.height / 2);
        canvasCtx.stroke();
    }
    
    // Initial draw
    drawFlatLine();

    // Format time (seconds -> mm:ss)
    function formatTime(seconds) {
        const min = Math.floor(seconds / 60);
        const sec = Math.floor(seconds % 60);
        return `${min}:${sec < 10 ? '0' : ''}${sec}`;
    }

    // Update progress bar and time
    function updateProgress() {
        if (!audio.duration) return;
        const { duration, currentTime } = audio;
        const progressPercent = (currentTime / duration) * 100;
        progressBar.style.width = `${progressPercent}%`;
        currentTimeEl.textContent = formatTime(currentTime);
        
        if (duration) {
            durationEl.textContent = formatTime(duration);
        }
    }

    // Set progress on click
    function setProgress(e) {
        initAudioContext(); // Ensure context is ready if they scrub first
        const width = this.clientWidth;
        const clickX = e.offsetX;
        const duration = audio.duration;
        audio.currentTime = (clickX / width) * duration;
    }

    // Play specific track
    function playTrack(index) {
        initAudioContext(); // Critical: Initialize Web Audio API

        const items = songList.querySelectorAll('li');
        const track = items[index];
        const songId = track.getAttribute('data-song-id');
        let src = track.getAttribute('data-src');

        // Check if we have a mapped internal song
        if (songId && songMap[songId]) {
            src = songMap[songId];
        }

        if (!src) {
            console.error('No audio source found for track:', index);
            return;
        }

        // Reset icons for all other tracks
        playIcons.forEach((icon, i) => {
            if (i !== index) icon.textContent = '▷';
        });

        if (currentTrackIndex === index && isPlaying) {
            // Pause action
            audio.pause();
            isPlaying = false;
            playIcons[index].textContent = '▷'; // Reset to play icon when paused
            drawFlatLine(); // Flatten waveform on pause
        } else {
            // Play action
            if (currentTrackIndex !== index) {
                audio.src = src;
                currentTrackIndex = index;
            }
            audio.play();
            isPlaying = true;
            playIcons[index].textContent = '||'; // Show pause icon
            
            // Highlight active track
            items.forEach(item => item.style.fontWeight = 'normal');
            track.style.fontWeight = 'bold';
            
            drawWaveform(); // Start animation
        }
    }

    // Event Listeners
    songList.querySelectorAll('li').forEach((item, index) => {
        item.addEventListener('click', () => playTrack(index));
    });

    audio.addEventListener('timeupdate', updateProgress);
    audio.addEventListener('ended', () => {
        isPlaying = false;
        playIcons[currentTrackIndex].textContent = '▷';
        progressBar.style.width = '0%';
        drawFlatLine(); // Flatten waveform on end
        // Optional: Play next track
        // if (currentTrackIndex < songList.children.length - 1) {
        //     playTrack(currentTrackIndex + 1);
        // }
    });

    progressContainer.addEventListener('click', setProgress);
});
